import { render, staticRenderFns } from "./DialogDetails.vue?vue&type=template&id=1825bda3"
import script from "./DialogDetails.vue?vue&type=script&lang=js"
export * from "./DialogDetails.vue?vue&type=script&lang=js"
import style0 from "./DialogDetails.vue?vue&type=style&index=0&id=1825bda3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports